import { useEffect, useState } from "react";
import axios from "axios";
import RoundAudio from "../../Components/RoundAudio";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import { translateEnglishToSpanishBatch } from "../../Util/translator";
import BASEURL from "../../Config/global";
import "./style.css";
import { useDispatch } from "react-redux";
import { userLogout } from "../../Store/Slices/APIs";
import CustomCard from "../CustomCard";
import PlayAllBanner from "../PlayAllBanner";

const SoundsAccordian = ({ currentSounds, handleClick, soundlist, clickListner, listner, list }) => {

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [categorizedSoundsData, setCategorizedSoundsData] = useState([]);
  const [translatedCategoryNames, setTranslatedCategoryNames] = useState({});
  const [translatedSubCategoryNames, setTranslatedSubCategoryNames] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    dispatch(userLogout())
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        setIsTranslating(true);
        const response = await axios.get(`${BASEURL}/api/sounds/allsoundscategories`);
        if (response.data.error != true) {
          const sortedData = response.data.data.sort(function (a, b) { return a.sequence - b.sequence })
          setCategorizedSoundsData(sortedData);
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  // Translate only category and sub-category names
  useEffect(() => {
    const applyCategoryTranslations = async () => {
      // Only translate when UI is Spanish
      if (i18n.language !== "es") {
        setTranslatedCategoryNames({});
        setTranslatedSubCategoryNames({});
        setIsTranslating(false);
        return;
      }

      if (!categorizedSoundsData || categorizedSoundsData.length === 0) return;

      setIsTranslating(true);

      try {
        const itemsForTranslation = [];

        // Collect top-level category names
        categorizedSoundsData.forEach((cat) => {
          if (cat?.id && cat?.name) {
            itemsForTranslation.push({
              id: cat.id,
              type: "category",
              name: cat.name,
            });
          }
        });

        // Collect sub-category names
        categorizedSoundsData.forEach((cat) => {
          if (
            cat?.children_category_data &&
            cat.children_category_data.length > 0
          ) {
            cat.children_category_data.forEach((sub) => {
              if (sub?.id && sub?.name) {
                itemsForTranslation.push({
                  id: sub.id,
                  type: "subCategory",
                  name: sub.name,
                });
              }
            });
          }
        });

        if (itemsForTranslation.length === 0) {
          setIsTranslating(false);
          return;
        }

        const texts = itemsForTranslation.map((item) => item.name);
        const batchResult = await translateEnglishToSpanishBatch(texts);

        if (!batchResult.success || !batchResult.translatedTexts) {
          throw new Error(batchResult.error || "Batch translation failed");
        }

        const categoryResults = [];
        const subCategoryResults = [];

        batchResult.translatedTexts.forEach((translated, idx) => {
          const item = itemsForTranslation[idx];
          if (!item || !translated) return;
          const mapped = { id: item.id, name: translated };
          if (item.type === "category") {
            categoryResults.push(mapped);
          } else if (item.type === "subCategory") {
            subCategoryResults.push(mapped);
          }
        });

        const catMap = {};
        categoryResults.forEach((item) => {
          if (item && item.id) {
            catMap[item.id] = item.name;
          }
        });

        const subCatMap = {};
        subCategoryResults.forEach((item) => {
          if (item && item.id) {
            subCatMap[item.id] = item.name;
          }
        });

        setTranslatedCategoryNames(catMap);
        setTranslatedSubCategoryNames(subCatMap);
      } catch (e) {
        console.error("SoundsAccordian category translation failed:", e);
        setTranslatedCategoryNames({});
        setTranslatedSubCategoryNames({});
      } finally {
        setIsTranslating(false);
      }
    };

    applyCategoryTranslations();
  }, [i18n.language, categorizedSoundsData]);



  return (
    <div className="row g-0">
      <div className="col-12">
        <Accordion
          defaultActiveKey={["0"]}
          alwaysOpen
          className="customAccordion sound-accordian"
        >
          {isTranslating ? (
            <div className="d-flex justify-content-center my-5">
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : categorizedSoundsData && categorizedSoundsData?.map((categorizedData, index) => {
            let sortedChildrens = categorizedData.children_category_data
            if (sortedChildrens?.length > 0) {
              sortedChildrens = sortedChildrens.sort(function (a, b) { return a.sequence - b.sequence })
            }
            return (
              (
                <Accordion.Item eventKey={index == 0 ? '0' : Math.random()} key={Math.random()}>
                  <Accordion.Header
                    style={{
                      backgroundImage: `url(${categorizedData?.banner})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundColor: '#1c3664',
                    }}
                  >
                    {(() => {
                      const categoryName = translatedCategoryNames[categorizedData.id] || categorizedData?.name || '';
                      return categoryName.toLowerCase() === 'featured'
                        ? t("home.featured")
                        : categoryName;
                    })()}
                  </Accordion.Header>
                  <Accordion.Body className={index > 0 ? 'accordion-body-spaced' : ''}>
                    <div className={index == 0 ? 'homeboxesWrapper' : 'audios-rows audioStrips stripedRows'}>
                      {categorizedData?.category_data?.length > 0 && categorizedData?.category_data?.map((item, idx) => (
                        index == 0 ? <CustomCard key={idx} image={item.image} item={item} /> : <RoundAudio key={idx} item={item} parentCategoryId={categorizedData.id} showThumnail={true} />
                      ))}
                    </div>
                    <div className="sub-category-accordian">
                      {sortedChildrens?.length > 0 && sortedChildrens?.map((categorizedDataiii, index2) => (
                        <Accordion.Item eventKey={Math.random()} key={Math.random()}>
                          <Accordion.Header
                            className="sub-category-header"
                            style={{
                              backgroundImage: `url(${categorizedDataiii?.banner})`,
                              backgroundSize: 'cover',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'right center',
                              backgroundColor: '#ffffff2b',
                            }}
                          >
                            {(() => {
                              const subCategoryName = translatedSubCategoryNames[categorizedDataiii.id] || categorizedDataiii?.name || '';
                              return subCategoryName.toLowerCase() === 'featured'
                                ? t("home.featured")
                                : subCategoryName;
                            })()}
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="audios-rows audioStrips stripedRows">
                              {categorizedData.id === 164 && (
                                <PlayAllBanner item={{ title: categorizedDataiii.name, id: categorizedDataiii.id }} tracks={categorizedDataiii?.category_data} />
                              )}
                              {categorizedDataiii?.category_data?.length > 0 && categorizedDataiii?.category_data?.map((item, idx) => (
                                <RoundAudio key={idx} item={item} parentCategoryId={categorizedData.id} showThumnail={true} />
                              ))}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              )
            )
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default SoundsAccordian;
